<script>
    import BasketService from '../services/api/BasketService';

    export default {
        name: "AddToBasket",
        computed: {
            addToBasketCount() {
                return this.basketItems.length
            },
            basketItems() {
                return this.$store.state.basket.items;
            }
        },
        methods: {
            getBasket() {
                BasketService.setLocale(this.$store.state.language.appLanguage);
                BasketService.getList()
                    .then(res => {
                        this.$store.commit('setBasket', res.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getBasketSimple() {
                BasketService.setLocale(this.$store.state.language.appLanguage);
                BasketService.getListSimple()
                    .then(res => {
                        this.$store.commit('setBasket', res.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            isBasket(id) {
                const idx = this.basketItems.findIndex(item => item.productId === id);

                return idx >=0
            },
            updateBasket(id) {
                this.$store.commit('updateBasket', id);
            }
        },
    }
</script>

<style scoped>

</style>
